var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPentagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_52_8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8656 2.53838C21.7109 1.14453 22.6336 0.447602 23.6422 0.178304C24.5329 -0.0594348 25.4671 -0.0594348 26.3578 0.178304C27.3664 0.447602 28.2891 1.14453 30.1344 2.53838L45.8273 14.3919C47.6726 15.7857 48.595 16.4827 49.1532 17.3968C49.6459 18.2041 49.9345 19.1276 49.9923 20.0818C50.0576 21.1625 49.7052 22.2901 49.0003 24.5454L43.0063 43.7246C42.3015 45.98 41.9491 47.1078 41.2852 47.9419C40.6991 48.6786 39.9433 49.2493 39.0883 49.6013C38.12 50 36.9796 50 34.6986 50H15.3014C13.0204 50 11.88 50 10.9116 49.6013C10.0566 49.2493 9.30097 48.6786 8.71478 47.9419C8.05093 47.1078 7.69851 45.98 6.99366 43.7246L0.999596 24.5454C0.294744 22.2901 -0.057695 21.1625 0.00771004 20.0818C0.0654445 19.1276 0.354089 18.2041 0.846839 17.3968C1.40488 16.4827 2.32754 15.7857 4.17286 14.3919L19.8656 2.53838Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8656 2.53838C21.7109 1.14453 22.6336 0.447602 23.6422 0.178304C24.5329 -0.0594348 25.4671 -0.0594348 26.3578 0.178304C27.3664 0.447602 28.2891 1.14453 30.1344 2.53838L45.8273 14.3919C47.6726 15.7857 48.595 16.4827 49.1532 17.3968C49.6459 18.2041 49.9345 19.1276 49.9923 20.0818C50.0576 21.1625 49.7052 22.2901 49.0003 24.5454L43.0063 43.7246C42.3015 45.98 41.9491 47.1078 41.2852 47.9419C40.6991 48.6786 39.9433 49.2493 39.0883 49.6013C38.12 50 36.9796 50 34.6986 50H15.3014C13.0204 50 11.88 50 10.9116 49.6013C10.0566 49.2493 9.30097 48.6786 8.71478 47.9419C8.05093 47.1078 7.69851 45.98 6.99366 43.7246L0.999596 24.5454C0.294744 22.2901 -0.057695 21.1625 0.00771004 20.0818C0.0654445 19.1276 0.354089 18.2041 0.846839 17.3968C1.40488 16.4827 2.32754 15.7857 4.17286 14.3919L19.8656 2.53838Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_52_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentagon);
export default __webpack_public_path__ + "static/media/pentagon.23c41fd7979ecb5ff85d1496276aff3f.svg";
export { ForwardRef as ReactComponent };